module.exports = __webpack_public_path__ + "static/dash-bg-afcfdf67764813472be185c43c6e7e39.png";